import i from 'icepick'
import { keyBy } from 'lodash'
import { transform, populate } from 'features/Cms/Cms.utils'

const initialState = {
  // cms entities
  // eg 'footer', 'blogPost' etc
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'CMS/GET_ENTRIES_FULFILLED': {
      const { items, assets, entries } = transform(action.payload.data)
      // Key items by id
      const newEntries = keyBy(entries, 'sys.id')
      const newAssets = keyBy(assets, 'sys.id')
      // Add the entries and assets to the state
      const entriesAndAssets = Object.assign({}, newEntries, newAssets)
      return i.assoc(state, action.meta.contentType, populate(entriesAndAssets, items))
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Cms.reducer.js